import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Settings = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path
        d="M11.864 14.773a2.864 2.864 0 1 0 0-5.728 2.864 2.864 0 0 0 0 5.728"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M13.685 2.645C13.335 2.5 12.89 2.5 12 2.5s-1.335 0-1.685.145A1.9 1.9 0 0 0 9.281 3.68c-.087.213-.123.462-.136.824a1.55 1.55 0 0 1-.754 1.291 1.55 1.55 0 0 1-1.496.008c-.32-.17-.553-.264-.783-.294a1.9 1.9 0 0 0-1.41.378c-.3.232-.524.617-.969 1.387s-.668 1.155-.717 1.532a1.9 1.9 0 0 0 .378 1.412c.142.183.34.337.646.53.451.283.741.766.741 1.299a1.54 1.54 0 0 1-.741 1.298c-.307.194-.505.348-.646.53a1.9 1.9 0 0 0-.378 1.413c.05.376.272.761.716 1.532.446.77.669 1.155.97 1.387a1.9 1.9 0 0 0 1.411.378c.23-.03.461-.124.782-.294a1.55 1.55 0 0 1 1.496.007c.46.268.735.76.754 1.292.013.363.048.61.136.824a1.9 1.9 0 0 0 1.034 1.034c.35.145.795.145 1.685.145s1.335 0 1.685-.145a1.9 1.9 0 0 0 1.034-1.034c.088-.213.123-.461.136-.824.02-.533.293-1.025.754-1.292a1.55 1.55 0 0 1 1.496-.007c.32.17.553.263.782.294a1.9 1.9 0 0 0 1.412-.378c.3-.231.523-.617.968-1.387s.668-1.155.717-1.532a1.9 1.9 0 0 0-.378-1.412c-.142-.183-.34-.337-.646-.53a1.55 1.55 0 0 1-.741-1.3c0-.532.29-1.015.741-1.297.307-.194.505-.348.646-.531a1.9 1.9 0 0 0 .378-1.412c-.05-.376-.273-.762-.716-1.532-.446-.77-.669-1.155-.97-1.387a1.9 1.9 0 0 0-1.411-.378c-.23.03-.461.124-.783.294a1.55 1.55 0 0 1-1.495-.008 1.55 1.55 0 0 1-.754-1.291c-.013-.363-.048-.611-.136-.824a1.9 1.9 0 0 0-1.034-1.034"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(Settings) as SvgIcon;
export { ForwardRef as ReactComponent };
